var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmoji4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8896 32C25.7262 32 32.8896 24.8366 32.8896 16C32.8896 7.16344 25.7262 0 16.8896 0C8.05309 0 0.889648 7.16344 0.889648 16C0.889648 24.8366 8.05309 32 16.8896 32Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5418 24.3368C23.5018 24.1777 22.5036 20.4443 16.8885 20.4443C11.2725 20.4443 10.2752 24.1777 10.2352 24.3368C10.1863 24.5297 10.2734 24.7297 10.4458 24.8292C10.6192 24.9279 10.8361 24.8986 10.9792 24.7608C10.9961 24.7439 12.7161 23.111 16.8885 23.111C21.0609 23.111 22.7818 24.7439 22.7978 24.7599C22.8832 24.8443 22.9969 24.8888 23.1107 24.8888C23.1854 24.8888 23.2609 24.8701 23.3294 24.8319C23.5036 24.7323 23.5907 24.5306 23.5418 24.3368Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5572 15.1114C12.7845 15.1114 13.7794 13.7185 13.7794 12.0003C13.7794 10.2821 12.7845 8.88916 11.5572 8.88916C10.3299 8.88916 9.33496 10.2821 9.33496 12.0003C9.33496 13.7185 10.3299 15.1114 11.5572 15.1114Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2212 15.1114C23.4485 15.1114 24.4435 13.7185 24.4435 12.0003C24.4435 10.2821 23.4485 8.88916 22.2212 8.88916C20.9939 8.88916 19.999 10.2821 19.999 12.0003C19.999 13.7185 20.9939 15.1114 22.2212 15.1114Z",
    fill: "#664500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji4);
export default __webpack_public_path__ + "static/media/emoji4.ecb5f04e400552c86c167d1821883286.svg";
export { ForwardRef as ReactComponent };